<template>
	<div
		class="flex flex-col gap-4 overflow-hidden rounded-[0.5rem] bg-green-50 p-4 shadow"
	>
		<div
			class="title flex items-center justify-center gap-2 text-green-950"
		>
			<slot name="title" />
		</div>
		<div class="body-1 text-center"><slot /></div>
		<div class="flex items-center justify-between gap-2">
			<slot name="actions" />
		</div>
	</div>
</template>
